import { ActiveFilterType } from "../components/FilterSection/types";

const getFilterAction = (
  label: ActiveFilterType | "Sharing" | "Amenities" | "Bills Included" | "Locality",
) => {
  switch (label) {
    case "Sort":
      return "sort_filter_clicked";
    case "Stay Duration":
      return "stay_duration_filter_clicked";
    case "Move in Month":
      return "move_in_month_filter_clicked";
    case "Room Type":
      return "room_type_filter_clicked";
    case "Budget":
      return "price_range_filter_clicked";
    case "University":
      return "university_filter_clicked";
    case "Locality":
      return "Locality_filter_clicked";
    case "Sharing":
      return "sharing_filter_clicked";
    case "Availability":
      return "availability_filter_clicked";
    case "Dual Occupancy":
      return "dual_occupancy_filter_clicked";
    case "Property Type":
      return "unit_type_filter_clicked";
    case "Guarantor":
      return "guarantor_filter_clicked";
    case "Distance from City Centre":
      return "distance_from_city_centre_filter_clicked";
    case "Housing Type":
      return "housing_type_filter_clicked";
    case "Amenities":
      return "amenities_filter_clicked";
    case "Bills Included":
      return "bills_included_filter_clicked";
    default:
      return "filter_clicked";
  }
};

export default getFilterAction;
